/* @flow */
import React from 'react';
import { css } from 'linaria';

import Colors from '../../constants/Colors';
import {
  BodyText,
  Text,
  Container,
  Spacer,
  FeatureBlock,
  Grid,
  GridCell,
  Icon,
  Title,
  Well,
  Button,
} from '../../components/core';
import withBreakpoint from '../../components/withBreakpoint';
import Responsive from '../../constants/Responsive';
import MediaQueries from '../../constants/MediaQueries';

const data = {
  'Reserve your unit':
    'Booking a Public Storage unit is super easy and only takes a few minutes. All online.',
  'Move in with Lugg': 'We come and pick up your items and bring them into your storage unit.',
  'Your stuff one tap away':
    'Have everything or just 1 item back home in just matter of a tap with Lugg.',
};

function PublicStorageBlock({ breakpoint }: { breakpoint: string }) {
  return (
    <Well backgroundColor={Colors.GrayLight}>
      <Container align="center">
        <Title weight="bold" size="32" align="center" className={TitleStyles}>
          Seamless integration with{' '}
          <Icon name="public-storage" className={PublicStorageLogoStyles} />
        </Title>
        <BodyText size="20" style={{ maxWidth: 640, marginRight: 'auto', marginLeft: 'auto' }}>
          With Lugg and Public Storage you store anything in a heartbeat and have it back with just
          a tap.
        </BodyText>
        <Spacer size={120} color={Colors.Divider} />
        <Title weight="bold" size="32" align="center">
          Get your items into storage today!
        </Title>
        <Spacer size={70} />
        <Grid>
          {Object.keys(data).map((key, idx) => (
            <GridCell
              key={idx}
              size={Responsive('size12of12', 'size4of12')}
              className={GridCellStyles}
              style={{ padding: '0 12px' }}>
              <FeatureBlock
                layout="vertical"
                figure={
                  <Text color={Colors.White} weight="bold" className={BadgeStyles}>
                    {idx + 1}
                  </Text>
                }
                title={
                  <Title size="20" weight="black" align="center">
                    {key}
                  </Title>
                }
                body={<BodyText size="14">{data[key]}</BodyText>}
              />
            </GridCell>
          ))}
        </Grid>
        <Spacer size={40} />
        <Button
          theme="publicStorage"
          bordered={false}
          onClick={() => (window.location = 'https://publicstorage.com')}>
          Reserve a Public Storage Unit{' '}
          {breakpoint !== 'small' && (
            <Icon
              name="arrow-white-right"
              style={{ verticalAlign: 'middle', margin: '-4px 0 0 10px' }}
            />
          )}
        </Button>
      </Container>
    </Well>
  );
}

export default withBreakpoint(PublicStorageBlock);

const TitleStyles = css`
  ${MediaQueries.SmallCapped} {
    line-height: 1.5;
  }
`;

const BadgeStyles = css`
  width: 40px;
  height: 40px;
  display: flex;
  background: ${Colors.PublicStorage};
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  margin: 0 auto -20px auto;
`;

const GridCellStyles = css`
  padding: 0 12px;
  margin-bottom: 30px;
`;

const PublicStorageLogoStyles = css`
  vertical-align: middle;
  margin-top: -6px;
  ${MediaQueries.SmallCapped} {
    width: 200px !important;
  }
`;



// WEBPACK FOOTER //
// ./src/ui/pages/components/PublicStorageBlock.js